<template>
  <div class="Waves">
    <div v-if="waves.length === 0">
      No orders have been assigned to a wave yet. You can assign orders to waves
      in the 'Pending' tab
    </div>
    <tabs v-else>
      <tab
        v-for="wave in sortWaves(waves)"
        :title="getTabTitle(wave)"
        html-title
        :key="wave.id"
        :tab-classes="getTabClasses(wave)"
      >
        <br />
        <Wave
          :wave="wave"
          :orders="getWaveOrders(wave)"
          :pickDate="pickDate"
          :allowSendToDispatchTrack="allowSendToDispatchTrack"
        />
      </tab>
    </tabs>
  </div>
</template>

<script>
import Wave from './Wave';
import orderBy from 'lodash.orderby';

export default {
  name: 'Waves',
  props: ['pickDate', 'orders', 'allowSendToDispatchTrack'],
  components: {
    Wave,
  },
  computed: {
    waves() {
      const waves = {};

      this.orders.forEach((order) => {
        if (order.wave && !waves[order.wave.id]) {
          waves[order.wave.id] = order.wave;
          waves[order.wave.id] = {
            ...waves[order.wave.id],
            uploadStatus: true,
          };
        }
        if (order.wave) {
          waves[order.wave.id].uploadStatus =
            waves[order.wave.id].uploadStatus && order.dtUploadStatus;
        }
      });

      return Object.values(waves);
    },
  },
  methods: {
    getTabTitle(wave) {
      let title = wave.name;
      if (wave.repSample) {
        title = '(s) ' + title;
      }
      if (wave.releasedAt) {
        title += ' (released)';
      }
      if (wave.uploadStatus === false) {
        title =
          "<i class='glyphicon glyphicon-exclamation-sign Wave__tab--not-uploaded'></i> " +
          title;
      }
      return title;
    },
    getTabClasses(wave) {
      return {
        'Wave__tab--released': !!wave.releasedAt,
        Wave__tab: !wave.releasedAt,
      };
    },
    sortWaves(waves) {
      const released = waves.filter((wave) => wave.releasedAt);
      const unreleased = waves.filter((wave) => !wave.releasedAt);

      return [
        ...orderBy(released, ['name'], ['asc']),
        ...orderBy(unreleased, ['name'], ['asc']),
      ];
    },
    getWaveOrders(wave) {
      return this.orders.filter(
        (order) => order.wave && order.wave.id === wave.id
      );
    },
  },
};
</script>

<style>
.Wave__tab a {
  font-weight: bold;
  color: #ff533d;
}
.Wave__tab--released a {
  font-style: italic;
  color: #003153;
}
.Wave__tab--not-uploaded {
  color: #ffbf00;
}
</style>



// WEBPACK FOOTER //
// src/views/Waves.vue